<section class="section-outset-b topbar-padding-top container">
  <app-breadcrumbs [breadcrumbs]="breadcrumbs" class="d-block mb-4"></app-breadcrumbs>

  <h1 class="mb-3 fw-bold">{{ 'collectie-overzicht-titel' | fromDictionary }}</h1>
  <!--  [@CardGridAnimation]="(collections$ | async)?.length" -->
  <ul class="row" *ngIf="collections$ | async as collections">
    <li class="col-6 col-md-4 mb-5" *ngFor="let collection of collections; trackBy: trackByFn">
      <app-collection-card [collection]="collection"></app-collection-card>
    </li>
  </ul>
</section>

<!-- <app-json-ld [json]="breadcrumbScheme"></app-json-ld> -->
